(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-logo"] && !Shopify.designMode) return;
  try {
    const cabnHeaderPreviewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');
  if (cabnHeaderPreviewThemeId) {
    document.querySelectorAll('[data-cabn-home-link]').forEach((link) => {
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set('preview_theme_id', cabnHeaderPreviewThemeId);
      link.href = `${url.pathname}${url.search}${url.hash}`;
    });
  }
  } catch(e) { console.error(e); }
})();

})();
